export { default as ContentfulResponsiveVideo } from './contentfulResponsiveVideo'



// WEBPACK FOOTER //
// ./src/modules/contentful/responsive/video/index.js